import React, { useContext } from 'react';
// design
import { Form, Input, Button, message } from 'antd';
// method
import { putMethod } from '../services/methods';
// context
import { GlobalContext } from "../context/globalContext";

export default function Password() {
    // context
    const { contextData, dispatch } = useContext(GlobalContext);
    const [form] = Form.useForm();
    const formItemLayout = {
        labelCol: {
            xs: { span: 24 },
            sm: { span: 2 },
        },
        wrapperCol: {
            xs: { span: 24 },
            sm: { span: 8 },
        },
    };

    const formSubmit = async () => {
        const update = await putMethod(`/user/change-password/${contextData.userData._id}`, form.getFieldsValue());
        if (update.status == 200) {
            message.success("İşlem başarılı.")
        }
        form.resetFields();
    };

    return (
        <Form
            {...formItemLayout}
            form={form}
            layout="horizontal"
            name="form_in_modal"
            initialValues={{
                modifier: 'public'
            }}
            onFinish={() => formSubmit()}
        >
            <Form.Item
                name="password"
                label="Yeni Şifre"
                rules={[
                    {
                        required: true,
                        message: 'Lütfen bu alanı doldurunuz!',
                    },
                ]}
            >
                <Input.Password />
            </Form.Item>

            <Form.Item>
                <Button shape="round" type="primary" htmlType="submit">
                    Kaydet
                </Button>
            </Form.Item>

        </Form>

    )
}